// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"278":"055d2e97","314":"16fb3b20","436":"056c5886","596":"c55dfd25","961":"c51007f8","995":"13fa3c91"}[chunkId] + ".css";
};